import React, { Component } from "react";
import isEmpty from 'lodash/isEmpty';
import map from 'lodash/map';
import { connect } from 'react-redux';
import * as BrowseAndNevigateSearchAction from '../../pages/BrowseAndNavigate/BrowseAndNevigateSearch/actions';
import commonUtil from "../../utils/commonUtil"

@connect(
    store => ({
        headerFooterData: store.globalData.data || {},
        globalObject: store.globleObject,
    }),
    { ...BrowseAndNevigateSearchAction },
)

class NewFooterComponentWap extends Component {
    constructor(props) {
        super(props);
        this.state = {
            activeIndex: null,
        };
    }

    toggleAccordion = (index) => {
        this.setState((prevState) => ({
            activeIndex: prevState.activeIndex === index ? null : index,
        }));
    };
    render() {
        return <footer id="footer" className="footer">
            {/* <div className="o-container__footer">
                <div className="m-container__footerLinkSession">
                    <a href="" className="a-footer__linkSession" id="signInFooter test22">Iniciar Sesión</a>
                </div>
            </div> */}

            <div className="o-container__footer items_links">
                {this.props.headerFooterData?.footerContent?.menu_items?.map((eachItem, index) => (
                    <div key={index} style={{width:"100%"}}>
                        <div
                            className="navigation_bar_header"
                            style={{ cursor: 'pointer', display: "flex", justifyContent: 'space-between', padding: "8px" }}
                            onClick={() => this.toggleAccordion(index)}
                        >
                            <span>{eachItem.label}</span>
                            <span className={`pull-right glyphicon ${this.state.activeIndex === index ? 'glyphicon-chevron-up' : 'glyphicon-chevron-down'}`}></span>
                        </div>
                        {this.state.activeIndex === index && (
                            <div className="pl-2" style={{ padding: "8px" }}>
                                {eachItem.items.map((option, idx) => (
                                    <a key={idx} style={{ display: 'block' }} href={option.url}>
                                        {option.label}
                                    </a>
                                ))}
                            </div>
                        )}
                        <hr style={{ borderTop: "1px solid #464646", margin: "0px", width: "100%" }} />
                    </div>
                ))}

                {/* <div className="m-footer__links-contact">
                    <a className="a-footer__boletin" href="https://www.liverpool.com.mx/tienda/paginas/Boletin/boletin/">Suscríbete a nuestro Newsletter</a>
                    <div
                        dangerouslySetInnerHTML={{
                            __html: this.props.headerFooterData?.footerContent?.content
                        }}
                    />
                </div> */}
            </div>

            <div className="o-container__footer items_links-social">
                <div className="m-footer__links">
                    <a className="a-footer__link" href="https://www.liverpool.com.mx/tienda/home">Comentarios y Sugerencias: </a>
                    <a className="a-footer__link" href="mailto:atencion@liverpool.com.mx">atencion@liverpool.com.mx</a>
                </div>

                <div className="m-footer__links --centerText">
                    {this.props.headerFooterData?.footerContent?.menu_links?.map((menuLink, index) => (
                        <React.Fragment key={index}>
                            <a className="a-footer__link" target="_blank" rel="noreferrer" href={menuLink.url}>
                                {menuLink.label}
                            </a>
                            {index !== this.props.headerFooterData.footerContent.menu_links.length - 1 && (
                                <span className="a-footer__slash">/</span>
                            )}
                        </React.Fragment>
                    ))}
                </div>

                <div className="m-footer__links --social">
                    {this.props.headerFooterData?.footerContent?.social_media?.map((socialMedia, index) => {
                        if (["Profeco", "Distintivo"].includes(socialMedia.label)) return null;
                        return (
                            <a key={index} target="_blank" rel="noreferrer" href={socialMedia.url} aria-label={`Liverpool - ${socialMedia.label}`}>
                                <i className={`icon-social-${socialMedia.label.toLowerCase()}`}></i>
                            </a>
                        );
                    })}
                </div>
            </div>

            <div className="o-container__footer items_links-rights">
                <p className="a-footer__misc">
                    <div
                        dangerouslySetInnerHTML={{
                            __html: this.props.headerFooterData?.footerContent?.extra_content
                        }}
                    />
                </p>
            </div>
        </footer>}
    }

export default NewFooterComponentWap;